import { notify } from 'components/Notifier';
import client from 'services/client';
import { Closure, ClosureValidateViolation, SortingCenter } from 'types';

export const postPreviewClosure = async (
  closure: Closure,
  sortingCenter: SortingCenter,
  t: (msg: string) => string,
  newWastage?: number,
): Promise<
  | {
      violations: ClosureValidateViolation[];
      warnings: ClosureValidateViolation[];
    }
  | undefined
> => {
  if (!closure || !sortingCenter) {
    return;
  }

  const sortingCenterId = sortingCenter['@id'].split('/')[3];
  const { month, year } = closure;
  try {
    let url = `/sorting_centers/${sortingCenterId}/closures/${year}-${month}/preview`;
    if (newWastage !== undefined) {
      const queryParams = new URLSearchParams({ newWastage: `${newWastage / 100}` });
      url += `?${queryParams.toString()}`;
    }

    await client.post(url, {});
    return {
      violations: [],
      warnings: [],
    };
  } catch (e) {
    // @ts-ignore
    if (e.status === 400) {
      // @ts-ignore
      if (e.response.body['hydra:description']) {
        return {
          violations: [
            {
              // @ts-ignore
              message: e.response.body['hydra:description'],
              // @ts-ignore
              propertyPath: e.response.body['hydra:description'],
              code: null,
              title: '',
            },
          ],
          warnings: [],
        };
      }
      // @ts-ignore
    } else if (e.status === 412) {
      // @ts-ignore
      if (e.response.body['violations'].length > 0) {
        return {
          // @ts-ignore
          violations: e.response.body['violations'],
          warnings: [],
        };
      }
      // @ts-ignore
    } else if (e.status === 417) {
      // @ts-ignore
      if (e.response.body['violations'].length > 0) {
        return {
          violations: [],
          // @ts-ignore
          warnings: e.response.body['violations'],
        };
      }
    } else {
      notify({
        message: t('errorGeneric'),
        severity: 'error',
      });
    }
  }
};
